import React, { useEffect, useState } from 'react';
import BsModal from '../Common/BsModal';
import { useConfig } from '../../DataStore/ConfigContext';

const AlertDateSelector = ({show, onClose, onConfirm, buttonLabel = "Confirm"}) => {
  
    const [dateRange, setDateRange] = useState({ opening_date: "", closing_date: "" });
    const {currentPeriod, getCurrentPeriod} = useConfig();

    useEffect(()=>{
        getCurrentPeriod();
    },[]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setDateRange({ ...dateRange, [name]: value });
    };

    const handleConfirm = () => {
        onConfirm(dateRange); // Pass the selected date range to the parent component
        onClose(); // Close the modal
    };

    const handleAutoFill = () => {
        if(currentPeriod){
            setDateRange({
                opening_date: currentPeriod.opening_date.db,
                closing_date: currentPeriod.closing_date.db
            });
        }
    }

    return (
        <BsModal
            show={show}
            onClose={onClose}
            title="Select Date Range"
            footer={
                <>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onClose}
                        >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleConfirm}
                        disabled={!dateRange.opening_date || !dateRange.closing_date}
                        >
                        <i className="fa fa-check-circle mr-1"></i> {buttonLabel || 'Confirm'}
                    </button>
               </>
            }
            >


            <div className="row">
              {/* Period From */}
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="periodFrom" className="font-weight-bold">
                    <i className="fa fa-calendar-alt mr-2 text-primary"></i> Period
                    From:
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="periodFrom"
                    name="opening_date"
                    value={dateRange.opening_date}
                    onChange={handleInputChange}
                    required
                  />
                  <small className="text-muted">
                    Select the starting date for the period.
                  </small>
                </div>
              </div>

              {/* Period To */}
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="periodTo" className="font-weight-bold">
                    <i className="fa fa-calendar-alt-check mr-2 text-primary"></i>{" "}
                    Period To:
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="periodTo"
                    name="closing_date"
                    value={dateRange.closing_date}
                    onChange={handleInputChange}
                    required
                  />
                  <small className="text-muted">
                    Select the ending date for the period.
                  </small>
                </div>
              </div>
            </div>
            
            {/* Auto-fill Financial Period Link */}
            <p className="text-muted text-left">
              <i className="fa fa-clock text-primary"></i>{" "}
              <span
                className="text-primary link"
                onClick={handleAutoFill}
              >
                Use Current Financial Period
              </span>
            </p>

        </BsModal>
    );
};

export default AlertDateSelector;
